import { Injectable } from '@angular/core';
import { UserReadableResource } from 'src/app/api/interfaces/localized-resource.interface';
import { AbstractApiV2Service } from '../../../api/services/abstract-api-v2.service';
import { HttpClient } from '@angular/common/http';
import { BackendErrorTranslatorService } from '../../../services/localization/backend-error-translator.service';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class OauthService extends AbstractApiV2Service<{ status: string }> implements UserReadableResource {
    public LocalizedResourceName = $localize`oauth`;
    public LocalizedPluralResourceName = $localize`oauth`;

    protected resourceName = 'oauth';

    constructor(http: HttpClient, backendErrorTranslator: BackendErrorTranslatorService, public authService: AuthService) {
        super(http, backendErrorTranslator);
    }

    public loginUser(formData: FormData) {
        return this.createSingle(formData, ``, 'login');
    }

    public logoutUser() {
        this.http.post<{ url: string }>(`${this.getLocation()}/logout`, {}).subscribe({
            next: (response: { url: string }) => {
                this.authService.clearStorage();
                window.location.href = '/';
            },
            error: () => {
                // show a toast error
            },
        });
    }
}
